//  Importing Dependancies
import React, { Component } from "react"
import { Link } from "react-router-dom"

//  Importing Components
import Divider from "../Divider/Divider"
import Button from "../Button/Button"
import MenuPreview from "../MenuPreview/MenuPreview"

//  Importing Images (SVG)

import hibachiMenu from "../images/menu.svg"
import salad from "../images/salad.svg"
import rice from "../images/rice.svg"
import scallops from "../images/seashell.svg"
import vegetables from "../images/vegetables.svg"
import steak from "../images/steak.svg"
import shrimp from "../images/shrimp.svg"
import chicken from "../images/chicken.svg"
import filetMignon from "../images/filet-mignon.svg"
import tuna from "../images/big-tuna.svg"
import mahi from "../images/mahi.svg"
import salmon from "../images/big-salmon.svg"
import lobster from "../images/lobster.svg"
import specialsIcon from "../images/specials-icon.svg"

// Light Svg

import lightSalad from "../images/light-salad.svg"
import lightRice from "../images/light-rice.svg"
import lightScallops from "../images/light-scallops.svg"
import lightVegetables from "../images/light-vegetables.svg"
import lightSteak from "../images/light-steak.svg"
import lightShrimp from "../images/light-shrimp.svg"
import lightChicken from "../images/light-chicken.svg"
import lightFiletMignon from "../images/light-filet-mignon.svg"
import lightTuna from "../images/light-tuna.svg"
import lightMahi from "../images/light-mahi.svg"
import lightSalmon from "../images/light-salmon.svg"
import lightLobster from "../images/light-lobster.svg"

// Jpg
import shrimpBg from "../images/shrimp.jpg"
import steakBg from "../images/steak.jpg"
import chickenBg from "../images/chicken.jpg"
import riceBg from "../images/fried-rice.jpg"
import saladBg from "../images/salad.jpg"
import vegetablesBg from "../images/vegetables.jpeg"

import salmonBg from "../images/salmon.jpeg"
import mahiBg from "../images/mahimahi.jpg"
import scallopsBg from "../images/scallops.jpg"
import tunaBg from "../images/tuna.jpg"
import filetMignonBg from "../images/filet-mignon.jpg"
import lobsterBg from "../images/lobster-tail.jpg"

//  Importing CSS
import "./Menu.css"

const Menu = props => {
  return (
    <div className="menu">
      <div className="menu__header-container">
        <div className="menu__bg" />
        <div className="menu__header">
          <img alt="Menu" className="menu__icon" src={hibachiMenu} />
          <h1>Starter Menu</h1>
          <div className="menu__desktop-description">
            <Divider />
            <p>
              This is our starter menu; perfectly crafted to ensure a delicious and fun Hibachi experience. Feel free to choose and exclude items to your taste and desire.
              <span> Every Hibachi & You party starts with the following:</span>
            </p>
          </div>
        </div>
      </div>
      <div className="menu__desktop-standard-menu">
        <MenuPreview
          isStarter={true}
          foodName="Shrimp"
          foodId="Shrimp"
          foodIcon={lightShrimp}
          foodBg={shrimpBg}
          bGsize="210%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={true}
          foodName="Steak"
          foodId="Steak"
          foodIcon={lightSteak}
          foodBg={steakBg}
          bGsize="210%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={true}
          foodName="Chicken"
          foodId="Chicken"
          foodIcon={lightChicken}
          foodBg={chickenBg}
          bGsize="210%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={true}
          foodName="Fried Vegetables"
          foodId="FriedVegetables"
          foodIcon={lightVegetables}
          foodBg={vegetablesBg}
          bGsize="210%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={true}
          foodName="Fried Rice"
          foodId="FriedRice"
          foodIcon={lightRice}
          foodBg={riceBg}
          bGsize="210%"
          bGpos="center"
        />
      </div>
      <div className="menu__standard">
        <div className="menu__submenu-header">
          <h2>Classic Hibachi</h2>
        </div>
        <Divider />
            <p>
              This is our starter menu; perfectly crafted to ensure a delicious and fun Hibachi experience. Feel free to choose and exclude items to your taste and desire.
              <span>Every Hibachi & You party starts with the following:</span>
            </p>
        <div className="menu__standard-item-container">
          <div className="menu__standard-item">
            <Link to="/fullmenu#Shrimp">
              <img alt="Shrimp" className="menu__food-icon" src={shrimp} />
              <span>Shrimp</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#Chicken">
              <img alt="Chicken" className="menu__food-icon" src={chicken} />
              <span>Chicken</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#Steak">
              <img alt="steak" className="menu__food-icon" src={steak} />
              <span>Steak</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#FriedRice">
              <img alt="rice" className="menu__food-icon" src={rice} />
              <span>Fried Rice</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#FriedVegetables">
              <img
                alt="vegetables"
                className="menu__food-icon"
                src={vegetables}
              />
              <span>Vegetables</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#Salad">
              <img alt="salad" className="menu__food-icon" src={salad} />
              <span>Salad</span>
            </Link>
          </div>
        </div>
        <Button img={hibachiMenu} text="Full Menu" link="fullmenu" />
      </div>

      <div className="menu__header-container">
        <div className="menu__bg-specials" />
        <div className="menu__header">
          <img alt="Menu" className="menu__icon" src={specialsIcon} />
          <h1>Specials Menu</h1>
          <div className="menu__desktop-description">
            <Divider />
            <p>
              All of our specials are cooked after our starter menu. Each
              special has its own price per person. Contact us to learn more.
            </p>
          </div>
        </div>
      </div>
      <div className="menu__desktop-standard-menu">
        <MenuPreview
          isStarter={false}
          foodName="Salmon"
          foodId="Salmon"
          foodIcon={lightSalmon}
          foodBg={salmonBg}
          bGsize="212%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={false}
          foodName="Mahi Mahi"
          foodId="MahiMahi"
          foodIcon={lightMahi}
          foodBg={mahiBg}
          bGsize="205%"
          bGpos="left"
        />
        <MenuPreview
          isStarter={false}
          foodName="Filet Mignon"
          foodId="FiletMignon"
          foodIcon={lightFiletMignon}
          foodBg={filetMignonBg}
          bGsize="230%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={false}
          foodName="Scallops"
          foodId="Scallops"
          foodIcon={lightScallops}
          foodBg={scallopsBg}
          bGsize="250%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={false}
          foodName="Tuna"
          foodId="Tuna"
          foodIcon={lightTuna}
          foodBg={tunaBg}
          bGsize="225%"
          bGpos="center"
        />
        <MenuPreview
          isStarter={false}
          foodName="Lobster Tail"
          foodId="LobsterTail"
          foodIcon={lightLobster}
          foodBg={lobsterBg}
          bGsize="230%"
          bGpos="center"
        />
      </div>
      <div className="menu__standard">
        <div className="menu__submenu-header">
          <h2>Treat Yourself To Something Special</h2>
        </div>
        <Divider />
        <p>
          All of our specials are cooked after our starter menu. Each special
          has its own price per person. Contact us to learn more.
        </p>
        <div className="menu__standard-item-container">
          <div className="menu__standard-item">
            <Link to="/fullmenu#Salmon">
              <img alt="Salmon" className="menu__food-icon" src={salmon} />
              <span>Salmon</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#Tuna">
              <img alt="Tuna" className="menu__food-icon" src={tuna} />
              <span>Tuna</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#LobsterTail">
              <img
                alt="Lobster Tail"
                className="menu__food-icon"
                src={lobster}
              />
              <span>Lobster Tail</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#MahiMahi">
              <img alt="Mahi Mahi" className="menu__food-icon" src={mahi} />
              <span>Mahi Mahi</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#Scallops">
              <img alt="Scallops" className="menu__food-icon" src={scallops} />
              <span>Scallops</span>
            </Link>
          </div>
          <div className="menu__standard-item">
            <Link to="/fullmenu#FiletMignon">
              <img
                alt="Filet Mignon"
                className="menu__food-icon"
                src={filetMignon}
              />
              <span>Filet Mignon</span>
            </Link>
          </div>
        </div>
        <Button img={hibachiMenu} text="Full Menu" link="fullmenu" />
      </div>
    </div>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/Menu/Menu.js